import { API_GENAI_SERVER_URL, API_GENAI_V1_SERVER_URL } from 'js/constants/api';

export const getGenAIBaseUrl = (endpoint) => {
  const endpointHasV1 = endpoint.startsWith('/v1') || endpoint.startsWith('v1/');
  const baseHasV1 = API_GENAI_SERVER_URL?.endsWith('/v1');
  return endpointHasV1 || baseHasV1 ? API_GENAI_SERVER_URL : API_GENAI_V1_SERVER_URL;
};
